import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a47b5f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-content" }
const _hoisted_2 = ["width", "height", "stroke", "stroke-width"]
const _hoisted_3 = ["transform"]
const _hoisted_4 = ["d"]

import { PropType } from 'vue'
import { PPTLatexElement } from '@/types/slides'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLatexElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTLatexElement>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-latex",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock("svg", {
          overflow: "visible",
          width: __props.elementInfo.width,
          height: __props.elementInfo.height,
          stroke: __props.elementInfo.color,
          "stroke-width": __props.elementInfo.strokeWidth,
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("g", {
            transform: `scale(${__props.elementInfo.width / __props.elementInfo.viewBox[0]}, ${__props.elementInfo.height / __props.elementInfo.viewBox[1]}) translate(0,0) matrix(1,0,0,1,0,0)`
          }, [
            _createElementVNode("path", {
              d: __props.elementInfo.path
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_3)
        ], 8, _hoisted_2))
      ])
    ], 4)
  ], 4))
}
}

})